import { RtoBulkScanReturn } from "@/interfaces/Return";
import ProductCounter from "@/components/product-counter/ProductCounter";
import { ReturnScanStatus } from "@/utils/rto-bulk-scan";
import { cn } from "@/lib/utils";
import React from "react";

interface BulkReturnScanRowProps {
  return_: RtoBulkScanReturn;
  scannedColisCount: number;
  expectedColisCount: number;
  status: ReturnScanStatus;
  onClick: () => void;
}

const rowStyles: Record<
  ReturnScanStatus,
  { border: string; tag: string }
> = {
  not_started: {
    border: "border-gray-300",
    tag: "bg-gray-100 text-gray-700",
  },
  in_progress: {
    border: "border-amber-500",
    tag: "bg-amber-100 text-amber-700",
  },
  complete: {
    border: "border-emerald-500",
    tag: "bg-emerald-100 text-emerald-700",
  },
};

const BulkReturnScanRow: React.FC<BulkReturnScanRowProps> = ({
  return_,
  scannedColisCount,
  expectedColisCount,
  status,
  onClick,
}) => {
  const styles = rowStyles[status];

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "w-full flex flex-col rounded-lg bg-white hover:bg-gray-50 my-2 border-2 p-3 space-y-2 text-left transition-colors duration-200",
        styles.border
      )}
    >
      <div className="flex items-start justify-between gap-2 w-full">
        <h2 className="text-lg font-semibold text-gray-800">
          Tournée N° {return_.numTournee}
          {return_.numDemande != null && ` - Demande ${return_.numDemande}`}
        </h2>
        <span
          className={cn(
            "text-xs font-semibold shrink-0 rounded-md px-2 py-1",
            styles.tag
          )}
        >
          {scannedColisCount} / {expectedColisCount} colis
        </span>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="text-sm font-bold text-gray-700">{return_.sellerName}</h3>
        {return_.countArticles != null && (
          <ProductCounter productCount={return_.countArticles} />
        )}
      </div>
    </button>
  );
};

export default BulkReturnScanRow;
